/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Side menu component styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const SideMenuStyled = styled.div.attrs({
    className: 'side-menu',
})<{ width: string }>`
    height: 100%;
    width: ${props => props.width};
    border: 1px solid ${colors.borderColorDisabled};
`;
